import Reporting from './ui/Reporting';

export default Reporting;
